import odata from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";

export default {
  ...odata("users"),
  ...rest("users"),
  getCurrentClient: async () => {
    return await apiClient.get("users/current");
  },
  updateCurrentUser: async (payload) => {
    return await apiClient.patch("users/current", payload);
  },
  changePassword: async (payload) => {
    return await apiClient.post("users/change-password", payload);
  },
  getById: function (id, payload) {
    return apiClient.get(`users/${id}`, {
      params: {
        relations: "roles,organizations",
      },
    });
  },
  getBilling: async () => {
    return await apiClient.get(`billing-info/current`);
  },
  impersonate: async (userId) => {
    return apiClient.post(`users/impersonate/${userId}`);
  },
  stopImpersonation: async () => {
    return apiClient.post(`users/stop-impersonation`);
  },
};
